import { useEffect, useState } from "react";
import { AllBookingDetailsApi } from "../../services/Api";
import { isAdmin, isAuthenticated } from "../../services/Auth";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import { Navigate } from 'react-router-dom';


export default function AllBookingDetails() {

    const [loading, setLoading] = useState(false);
    const [bookings, setBookings] = useState([]);


    useEffect(() => {
        if (isAuthenticated() && isAdmin()) {
            setLoading(true);
            AllBookingDetailsApi().then((response) => {
                setBookings(response.data.bookings)
            })
            setLoading(false);
        }
    }, [])

    const bookingData = () => {
        const data = {
            columns: [
                {
                    label: 'Booking ID ↕',
                    field: 'id',
                    sort: 'asc'
                },
                {
                    label: 'Name ↕',
                    field: 'name',
                    sort: 'asc'
                },
                {
                    label: 'Email ↕',
                    field: 'email',
                    sort: 'asc'
                },
                {
                    label: 'Phone No. ↕',
                    field: 'pno',
                    sort: 'asc'
                },
                {
                    label: 'Address ↕',
                    field: 'address',
                    sort: 'asc'
                },
                {
                    label: 'Date ↕',
                    field: 'date',
                    sort: 'asc'
                },

                {
                    label: 'Booking Details',
                    field: 'actions',
                    sort: 'asc'
                }

            ],
            rows: []
        }

        bookings.forEach(booking => {
            data.rows.push({
                id: booking._id,
                name: booking.fullName,
                email: booking.email,
                pno: booking.pno,
                address: booking.address,
                date: booking.createdAt,
                actions: (
                    <>
                        <Link className="me-1" to={`/admin/bookingiddetails/${booking._id}`}>Full Booking Detils</Link>
                    </>)
            })
        })

        return data;
    }

    if (!isAuthenticated() || !isAdmin()) {
        return <Navigate to="/login" />
    }
    return (
        <>
            <div className="container-fluid p-5 bg-body-secondary">
                <h1>Booking List</h1>
                <div className="bg-body-tertiary bg-opacity-50">
                    {!loading &&
                        <MDBDataTable
                            data={bookingData()}
                            bordered
                            striped
                            hover
                            className="px-3"
                        />
                    }
                </div>
            </div>
        </>
    )
}
